import React from "react";
import { Box, Typography, FormControlLabel, Switch, TextField } from "@material-ui/core";
import { i18n } from "../../translate/i18n";

const defaults = { version: 1, enabled: false, respondOnTransfer: true, historyEnabled: false,
  capabilityHistoryEnabled: false, recentMessageLimit: 20, maxContextChars: 12000,
  historyPageSize: 20, maxHistoryCalls: 2, contactHistoryDays: 0,
  initialContactHistoryDays: 0, compactOperationalContext: false };
export default function AiContinuitySettings({ profile, setFieldValue }) {
  const stored = profile?.metadata?.continuityPolicy;
  const t = key => i18n.t(`aiContinuity.${key}`);
  if (stored && stored.version !== 1) return <Typography color="error">{t("unsupported")}</Typography>;
  const policy = { ...defaults, ...stored };
  const save = patch => setFieldValue("aiAgentProfile.metadata.continuityPolicy", { ...policy, ...patch });
  return <Box mt={2} mb={2}>
    <Typography variant="subtitle2">{t("title")}</Typography>
    <Typography variant="body2" color="textSecondary">{t("help")}</Typography>
    {["enabled", "respondOnTransfer", "historyEnabled", "capabilityHistoryEnabled", "compactOperationalContext"].map(key =>
      <FormControlLabel key={key} label={t(key)} control={<Switch color="primary" checked={Boolean(policy[key])}
        disabled={key !== "enabled" && (!policy.enabled || (key === "capabilityHistoryEnabled" && !policy.historyEnabled))}
        onChange={event => save({ [key]: event.target.checked })} />} />)}
    {policy.enabled && <>
      <Typography variant="body2" color="textSecondary">{t("limitsHelp")}</Typography>
      <Typography variant="body2" color="textSecondary">{t("bootstrapHelp")}</Typography>
      {[["recentMessageLimit", 1, 20], ["maxContextChars", 1000, 12000], ["historyPageSize", 1, 20],
        ["maxHistoryCalls", 1, 2], ["contactHistoryDays", 0, 90], ["initialContactHistoryDays", 0, 90]].map(([key, min, max]) =>
        <TextField key={key} fullWidth variant="outlined" margin="dense" type="number" label={t(key)}
          inputProps={{ min, max, step: 1 }} value={policy[key]}
          onChange={event => save({ [key]: event.target.value === "" ? "" : Number(event.target.value) })} />)}
    </>}
  </Box>;
}
